<template>
  <div class="users-main-container">
    <span class="multiple-avatar-container">
      <figure class="avatar-container multiple-avatar" :data-balloon="user.userName" data-balloon-pos="right">
        <img :src="avatar(user.avatar)" @error="altImg" alt="Team Member Avatar">
        <i v-if="isLeader" class="fas fa-star leader-icon"></i>
      </figure>
      <div class="name-container">
        <h2>{{ userName }}</h2>
        <p v-for="(text, index) in texts" :key="index">{{ text }}</p>
      </div>
    </span>
  </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'

export default {
  props: ['judge'],
  computed: {
    userName: function () {
      return this.user.fullName ?? this.user.userName
    },
    user: function () {
      if (this.judge) {
        return this.judge.user
      }
      return null
    },
    isLeader: function () {
      return this.judge.customRole === 'Judge Team Lead'
    },
    texts: function () {
      if (this.user) {
        const judgeProject = this.$store.getters.getJudgeProjectByUserID(this.user.id)
        if (judgeProject) {
          if (!judgeProject || !judgeProject.pollSummary || !judgeProject.pollSummary.userAnswers) {
            return []
          }
          return judgeProject.pollSummary.userAnswers.map(m => m.answer)
        }
      }
      return []
    }
  },
  methods: {
    avatar: function (url) {
      return imageProxy.thumbnailXl(url)
    },
    altImg: function (e) {
      e.target.src = 'https://www.engineering.com/static/purple-logo-icon.svg'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .users-main-container {
    color: #aaaaaa;
    width: 100%;
    padding: 0.2rem 0.5rem 0.5rem 0.5rem;
    display: flex;
    min-height: 60px;
    height: 60px;
    font-family: $primary-font;
    @include touch {
      padding-left: 0.5rem;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .leader-icon {
      position: absolute;
      right: 0;
      bottom: 0;
      color: gold;
    }
  }
  .avatar-container {
    width: 3.5rem;
    height: 3.5rem;
    display: inline-block;
    margin-right: 0.5rem;
    z-index: 2;
    overflow: visible;
    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .name-container {
    h2 {
      font-size: 0.7rem;
      font-weight: 800;
      font-family: $primary-font;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 180px;
      margin-top: 5px;
      margin-bottom: 2px;
      @include mobile {
        max-width: 91px;
        font-size: 0.75rem;
      }
    }
    p {
      font-size: 0.5rem;
      text-transform: uppercase;
    }
    color: black;
  }
  .multiple-avatar-container {
    .multiple-avatar{
      position: relative;
    }
  }
</style>
